import { Modal, Input, Select, message, Button } from 'antd';
import React, { FC, useState, useEffect } from 'react';
import { isProOrSgp } from '@/infrastructure/auth';
import { getProductId } from '@/infrastructure/product-info';
import { DEFECT_PLATFORM_NAME, TapdParams } from '@/presentation/components/tapd-info';
import { bindTapdIssue } from '@/presentation/components/tapd-info/api';
import { useStores } from '@/presentation/store';
import { FilterOptions } from '@/proto/alert';
import { getTypeByZone } from '@/proto/issue';
import style from './index.module.scss';
import { useTranslation } from 'react-i18next';

interface IPros {
  visible: boolean;
  bindParams: TapdParams;
  onHide: () => void;
  onSubmit: () => void;
}

/**
 * 关联缺陷单组件
 */

export const BindTapdModal: FC<IPros> = (props) => {
  const { t } = useTranslation();
  const { visible, bindParams, onHide, onSubmit } = props;
  const [tapdLists, setTapdLists] = useState<FilterOptions[]>([]);
  const [tapdId, setTapdId] = useState('');
  const [workspaceId, setWorkspaceId] = useState('');
  const { tapdList } = useStores().TapdStore;
  const { defectList } = useStores().DefectStore;
  const [loading, setLoading] = useState(false);

  const getBugIdFromUrl = (url: string) => {
    const params = url?.split('?')[1]?.split('&') || url?.split('/')?.slice(-1)?.[0];
    if (params) {
      const paramsObj: Record<string, any> = {};
      for (const param of params) {
        const [key, value] = param?.split('=');
        paramsObj[key] = value;
      }
      return paramsObj?.bug_id ?? params;
    }
    return undefined;
  };

  const updateTapd = async () => {
    if (!workspaceId) {
      message.warning(t('请选择需要关联的{{platform}}项目', { platform: DEFECT_PLATFORM_NAME }));
      return;
    }
    if (!tapdId) {
      message.warning(t("请输入需要关联的缺陷单id"));
      return;
    }
    setLoading(true);
    const succ: any = await bindTapdIssue({
      productId: getProductId(),
      type: getTypeByZone(bindParams.type),
      issueKey: bindParams.issueKey,
      tapdId: getBugIdFromUrl(tapdId) ?? tapdId,
      issueUrl: tapdId,
      workSpaceId: workspaceId,
    });

    setLoading(false);
    if (succ) {
      message.success(t("关联成功"));
    } else {
      message.error(succ?.msg ?? t("未知错误"));
      return;
    }
    onSubmit();
    onHide();
  };

  useEffect(() => {
    if (isProOrSgp()) {
      return;
    }
    const list: FilterOptions[] = [];
    tapdList.forEach((item) => {
      if (item.workspaceName && item.workspaceId) {
        list.push({ label: item.workspaceName, value: item.workspaceId });
      }
    });
    setTapdLists(list);
  }, [tapdList]);

  useEffect(() => {
    if (isProOrSgp()) {
      const list: FilterOptions[] = [];
      defectList.forEach((item) => {
        list.push({ label: item.projectName ?? '', value: item.projectId ?? '' });
      });
      setTapdLists(list);
    }
  }, [defectList]);

  return (<Modal
    centered
    title={t("关联缺陷单")}
    footer={null}
    visible={visible}
    onOk={() => updateTapd()}
    onCancel={() => onHide()}
    className={style.bindModal}
  >
    <div style={{ display: 'flex', marginBottom: '20px', width: '380px', lineHeight: '30px' }}>
      <span style={{ width: '80px', textAlign: 'right', marginRight: '8px' }}>
        {isProOrSgp() ? t("关联项目：") : t("Tapd项目：")}
      </span>
      <Select
        placeholder={t('请选择{{platform}}项目', { platform: DEFECT_PLATFORM_NAME })}
        options={tapdLists}
        style={{ width: '300px' }}
        onChange={(changeValue: string) => setWorkspaceId(changeValue)}
      />
    </div>
    <div style={{ display: 'flex', marginBottom: '20px', width: '380px', lineHeight: '30px' }}>
      <span style={{ width: '80px', textAlign: 'right', marginRight: '8px' }}>
        {t("缺陷单：")}
      </span>
      <Input
        placeholder={t("请输入需要关联的缺陷单的ID或者链接")}
        required={true}
        style={{ width: '300px' }}
        onChange={(e: any) => setTapdId(e.target.value)}
      />
    </div>
    <div style={{ textAlign: 'right' }}>
      <Button
        type='primary'
        loading={loading}
        onClick={() => {
          updateTapd();
        }}
        style={{ marginLeft: '20px' }}>
        {t("确定")}
      </Button>
    </div>
  </Modal>);
};
